import { render, staticRenderFns } from "./DashboardCustomizado.vue?vue&type=template&id=b9016846&scoped=true"
import script from "./DashboardCustomizado.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizado.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomizado.vue?vue&type=style&index=0&id=b9016846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9016846",
  null
  
)

export default component.exports